import React from "react";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { PATH_GROUP_THERAPY } from "../utils/constants";
import groupsData from "../data/groups.json";
import { Group } from "../types/group";
import { GroupCard } from "../components/common/GroupCard";

export default function GroupTherapyPage() {
  const groups = (groupsData as { groups: Group[] }).groups;

  return (
    <>
      <SEOHelmet page="gruppentherapie" pathname={PATH_GROUP_THERAPY} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalBusiness",
          "name": "Ergotherapie Rottweil - Lisa Spreitzer",
          "description": "Soziales Kompetenztraining und therapeutische Gruppenangebote für Kinder und Erwachsene in Rottweil.",
          "url": "https://ergorw.de/gruppentherapie",
          "telephone": "+49-741-89698293",
          "email": "info@ergorw.de",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Auf dem Wall 29",
            "addressLocality": "Rottweil",
            "addressRegion": "Baden-Württemberg",
            "postalCode": "78628",
            "addressCountry": "DE"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "48.1684",
            "longitude": "8.6278"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "07:00",
              "closes": "17:00"
            }
          ],
          "founder": {
            "@type": "Person",
            "name": "Lisa Spreitzer",
            "jobTitle": "Ergotherapeutin"
          },
          "areaServed": {
            "@type": "City",
            "name": "Rottweil"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Gruppentherapien",
            "itemListElement": groups.map((group) => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "MedicalTherapy",
                "name": group.title,
                "description": group.description || `Therapeutisches Gruppenangebot: ${group.title}`
              }
            }))
          },
          "sameAs": [
            "https://www.instagram.com/ergotherapie_zeittraeume/"
          ]
        })}
      </script>

      <section aria-labelledby="groups-heading">
        <header className="mb-6 sm:mb-8">
          <h1
            id="groups-heading"
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white"
          >
            Gruppentherapien
          </h1>
          <p className="mt-4 text-base text-gray-500 dark:text-gray-400 max-w-3xl">
            Entdecken Sie unsere aktuellen Gruppentherapie-Angebote. Klicken Sie eine Gruppe an um die PDF herunterzuladen.
          </p>
        </header>

        {groups.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">Aktuell sind keine Gruppen eingetragen.</p>
        ) : (
          <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
            {groups.map((g) => (
              <GroupCard key={g.id} group={g} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}


